import i18n from "@i18n";

const normalize = (value: string): string =>
    value
        .trim()
        .replace(/\s+/g, " ")
        .replace(/[.!]+$/g, "")
        .toLowerCase();

const firstNonEmptyLine = (value: string): string =>
    value
        .split("\n")
        .map((line) => line.trim())
        .find((line) => line.length > 0) ?? value.trim();

const MESSAGE_KEY_BY_NORMALIZED_MESSAGE: Record<string, string> = {
    "cannot edit an active api key":
        "private:entityApiKeys.errors.cannotEditActive",
    "you cannot change activation state":
        "private:entityApiKeys.errors.cannotChangeActivationState",
    "you cannot change entity":
        "private:entityApiKeys.errors.cannotChangeEntity",
    "this field is required": "private:entityApiKeys.errors.fieldRequired",
};

export const getEntityApiKeyToastErrorMessage = (error: unknown): string => {
    const rawMessage =
        typeof (error as { message?: unknown } | null)?.message === "string"
            ? (error as { message: string }).message
            : String(error);
    const firstLine = firstNonEmptyLine(rawMessage);

    const key = MESSAGE_KEY_BY_NORMALIZED_MESSAGE[normalize(firstLine)];
    if (!key) return firstLine;

    return i18n.t(key);
};
